module.exports = __webpack_public_path__ + "static/media/hall.2475cf3d.jpg";